module.exports = __webpack_public_path__ + "static/media/Tile Image - Freezone - SF 11078-2 (1).6113ce4e.png";